export default[
    {
        name:"CustomerManage",
        path:"/SoftWare/CustomerManage",
        component:() => import("@/view/SoftWare/customermanage"),
        meta:{
            title:"客户管理",
        }
    },
    {
        name:"OrderManagement",
        path:"/SoftWare/OrderManagement",
        component:() => import("@/view/SoftWare/ordermanagement"),
        meta:{
            title:"订单管理",
        }
    },
    {
        name:"ProjectManagement",
        path:"/SoftWare/ProjectManagement",
        component:() => import("@/view/SoftWare/projectmanagement"),
        meta:{
            title:"项目管理",
        }
    },
    {
        name:"DeclarationManage",
        path:"/SoftWare/DeclarationManage",
        component:() => import("@/view/SoftWare/declarationmanage"),
        meta:{
            title:"申报管理",
        }
    },
    {
        name:"AnnualFeeReminder",
        path:"/SoftWare/AnnualFeeReminder",
        component:() => import("@/view/SoftWare/annualFeereminder"),
        meta:{
            title:"年费管理",
        }
    },
    {
        name:"More",
        path:"/SoftWare/More",
        component:() => import("@/view/SoftWare/more"),
        meta:{
            title:"更多实例",
        }
    }
]